
$(function () {
    let width = window.innerWidth;
    
    if(width > 1024)  {
        const item = $('.js-topItem');
        $(item).find('ul').hide();
        $(item).next('ul').hide();
    
        $(item).hover(function(){
            $(this).find('.js-childList').stop().slideDown(400);
            },function(){
            $(this).find('.js-childList').stop().slideUp(400);
        });
    } else  {
        const item = $('.js-topItem');
        $(item).find('ul').hide();
        $(item).next('ul').hide();
    
        $(item).on('click' , function(e){
            $('.js-topListSp').not(this).slideDown();
            $(this).next('.js-childListSp').slideToggle(400);
            e.preventDefault();
        });
    }
});


